import Vue from 'vue';
import Vuex from 'vuex';
import SensorsService from '../services/SensorsService';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    sensors: {
      list: [],
      current: null,
    },
    historicalData: {
      last: null,
      sensor: null,
    },
    boundaries: null,
    loading: 0,
  },

  mutations: {
    setSensors(state, list) {
      state.sensors = { ...state.sensors, list };
    },

    setSensor(state, data) {
      state.sensors = { ...state.sensors, current: data };
    },

    setBoundaries(state, boundaries) {
      state.boundaries = boundaries;
    },

    setLoading(state, isLoading) {
      state.loading = isLoading
        ? state.loading + 1
        : state.loading - 1;
    },

    setLastChange(state, change) {
      const last = Object.keys(change)
        .reduce(
          (last, key) => ({
            ...last,
            [key]: (change[key] instanceof Array
              ? change[key].map(({ value }) => value).reverse()
              : change[key]
            ),
          }),
          {}
        );

      state.historicalData = {
        ...state.historicalData,
        last,
      };
    },

    setHistoricalData(state, data) {
      const { id, sensors } = data;
      const sensor = sensors.reduce(
        (sum, item) => ({ ...sum, [item.type]: item.history }),
        { id },
      );

      state.historicalData = {
        ...state.historicalData,
        sensor,
      };
    },
  },

  getters: {
    sensors: state => state.sensors.list,
    sensor: state => state.sensors.current,
    boundaries: state => state.boundaries,
    isLoading: state => state.loading > 0,
    lastChange: state => state.historicalData.last,
    measurements: state => state.historicalData.sensor,
  },

  actions: {
    getSensors({ commit, getters }) {
      commit('setLoading', true);
      SensorsService.getSensors(getters.boundaries)
        .then(({ data }) => {
          commit('setSensors', data);
          return Promise.resolve();
        })
        .catch(() => Promise.resolve())
        .finally(() => commit('setLoading', false));
    },

    getSensor({ commit, getters }, id) {
      const { sensor } = getters;
      commit(
        'setSensor',
        { ...(!sensor || id !== sensor.id ? {} : getters.sensor), id, loading: true },
      );

      return SensorsService.getSensor(id)
        .then(({ data }) => {
          if (getters.sensor.id === id) {
            commit('setSensor', data);
          }
          return Promise.resolve();
        });
    },

    getHistoricalData({ commit, getters }, timePeriod) {
      commit('setLoading', true);

      const { start, end, sensor, id, updateLastChange } = timePeriod;

      SensorsService.getHistoricalData(id, start, end, sensor)
        .then(({ data }) => {
          commit(
            'setHistoricalData',
            { id: data.id, sensors: data.sensors },
          );
          
          if (updateLastChange) {
            commit('setLastChange', getters.measurements);
          }
        })
        .finally(() => commit('setLoading', false));
    },
  },
})
